import React from 'react';
import { motion } from 'framer-motion';
import { T, springs } from '../../lib/tokens';

const variantStyles = {
  ghost: {
    background: 'rgba(0,0,0,0.03)',
    color: T.textMid,
    border: '1px solid rgba(0,0,0,0.08)',
  },
  primary: {
    background: T.amber,
    color: '#fff',
    border: 'none',
    boxShadow: '0 2px 8px rgba(212,146,30,0.3)',
  },
  glass: {
    background: T.glass,
    backdropFilter: 'blur(12px)',
    color: T.text,
    border: `1px solid ${T.glassBorder}`,
    boxShadow: T.shadowSm,
  },
  danger: {
    background: 'rgba(224,88,88,0.04)',
    color: T.red,
    border: '1px solid rgba(224,88,88,0.15)',
  },
};

const hoverVariants = {
  ghost:   { background: 'rgba(0,0,0,0.06)' },
  primary: { background: '#c0841a', boxShadow: '0 4px 12px rgba(212,146,30,0.4)' },
  glass:   { background: 'rgba(255,255,255,0.9)' },
  danger:  { background: 'rgba(224,88,88,0.08)' },
};

export const Btn = ({ children, onClick, variant = 'ghost', small, style: s, disabled }) => {
  const base = {
    display: 'inline-flex', alignItems: 'center', gap: 6,
    padding: small ? '5px 12px' : '8px 16px',
    borderRadius: 10, cursor: disabled ? 'default' : 'pointer',
    fontSize: small ? 12 : 13, fontWeight: 500,
    fontFamily: 'inherit',
    transition: 'all 0.15s ease',
    opacity: disabled ? 0.5 : 1,
    ...variantStyles[variant],
    ...s,
  };

  return (
    <motion.button
      style={base}
      onClick={disabled ? undefined : onClick}
      whileHover={!disabled ? hoverVariants[variant] : undefined}
      whileTap={!disabled ? { scale: 0.97 } : undefined}
      transition={springs.snappy}
    >
      {children}
    </motion.button>
  );
};
